import * as uuidLib from "uuid";

export function generate() {
    return uuidLib.v4();
}

export function modifySection(section:number, origin: string, custom:string) {
    let parts = origin.split('-');

    if (parts[section] && custom) {
        let replaceLen = parts[section].length;
        let newChars = custom.replace(/[\W_]+/g,"")
                        .substring(0, replaceLen)
                        .toUpperCase();
        parts[section] = parts[section].substring(0, replaceLen - newChars.length) + newChars;
    }

    return parts.join('-');
}

export const friendifyUUID = function(node, prefix) {
    prefix = prefix || '';
    let origin = node.UUID;
    let parts = origin.split('-');
    let base = node.Name || node.DeviceType || null;

    if (base) {
        return modifySection(4, origin, prefix + base);
    }
}

export const recursiveUUIDExtract = function(structure, keys = [ "UUID" ]) {
    let UUIDList = [];
    if (!structure) {
        return UUIDList;
    }

    for (let key of keys) {
        if (structure[key]) {
            UUIDList.push(structure[key]);
        }
    }
    for (let key in structure) {
        let item = structure[key];

        if (item && typeof item === "object") {
            UUIDList = UUIDList.concat(recursiveUUIDExtract(item, keys));
        }
    }

    return UUIDList;
}

export const recursiveUUIDReplace = function(structure, table) {
    for (let key in structure) {
        let item = structure[key];
        if (typeof item === "object") {
            recursiveUUIDReplace(item, table);
        } else if (typeof item === "string" && table[item] && item !== table[item]) {
            structure[key] = table[item];
            // console.log('UUID IS CHANGING ', item, " => ", table[item]);
        }
    }
}